import { render, staticRenderFns } from "./ProductBrandDeleteModal.vue?vue&type=template&id=56223122&scoped=true&"
import script from "./ProductBrandDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ProductBrandDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56223122",
  null
  
)

export default component.exports